(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/helpers/taggedTemplateLiteralLoose', 'react', 'emotion', '../../styles'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/helpers/taggedTemplateLiteralLoose'), require('react'), require('emotion'), require('../../styles'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.taggedTemplateLiteralLoose, global.react, global.emotion, global.styles);
    global.VerticalNavDivider = mod.exports;
  }
})(this, function (exports, _taggedTemplateLiteralLoose2, _react, _emotion, _styles) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _taggedTemplateLiteralLoose3 = _interopRequireDefault(_taggedTemplateLiteralLoose2);

  var React = _interopRequireWildcard(_react);

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _templateObject = (0, _taggedTemplateLiteralLoose3.default)(['\n    margin-top: 0;\n    margin-bottom: 0;\n  '], ['\n    margin-top: 0;\n    margin-bottom: 0;\n  ']),
      _templateObject2 = (0, _taggedTemplateLiteralLoose3.default)(['\n    width: 99%;\n    // Defaults to 1px solid rgba(0,0,0,.1), which is likely a better option.\n    // border-top: 1px solid ', ';\n  '], ['\n    width: 99%;\n    // Defaults to 1px solid rgba(0,0,0,.1), which is likely a better option.\n    // border-top: 1px solid ', ';\n  ']);

  var VerticalNavDivider = function VerticalNavDivider() {
    return React.createElement('hr', { className: (0, _emotion.cx)(classNames.hrReset, classNames.divider) });
  };

  var classNames = {
    hrReset: (0, _emotion.css)(_templateObject),
    divider: (0, _emotion.css)(_templateObject2, _styles.colors.mercury)
  };

  exports.default = VerticalNavDivider;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/VerticalNav/VerticalNavDivider.js
// module id = 2035
// module chunks = 1